<iframe allow="fulscreen" [src]="flutterAppUrl | safe" frameBorder="0" style="width: 100%;min-height: 600px;"></iframe>